// extracted by mini-css-extract-plugin
export default {"list":"list_list__aVtaF"};